export const MEMBER_LOGIN_URL = process.env.REACT_APP_MST_MEMBER_LOGIN_URL || "#";
export const MEMBER_PORTAL_URL = process.env.REACT_APP_MST_MEMBER_PORTAL_URL || "#";
export const MEMBER_REGISTER_URL = process.env.REACT_APP_MST_MEMBER_REGISTER_URL || "#";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "About MST", to: "/about" },
  { label: "Membership", to: "/membership" },
  { label: "Ecosystem", to: "/ecosystem" },
  { label: "News", to: "/news" },
  { label: "Contact", to: "/contact" },
];

export const LOGO = "/mst-logo.png";
export const HERO_IMG = "/images/hero.jpg";
export const BOARDROOM_IMG = "/images/boardroom.jpg";
